import { Avatar, AvatarFallback, AvatarImage } from '@/components/shadcn/ui/avatar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/ui/popover';
import { Separator } from '@/components/shadcn/ui/separator';
import { Button } from '../shadcn/ui/button';
import { LogOutIcon, Settings, User2 } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import MenuTabs, { TokenPayload } from './tabs/MenuTabs';
import { useAuthContext } from '@/context/AuthContext';
import { auth } from '../../firebase';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { getTokenFromStorage } from '@/utils/getToken';
import { jwtDecode } from 'jwt-decode';

const NavBar = () => {
  const photoURL = auth.currentUser?.photoURL || ''; // Foto do usuário ou string vazia
  const navigate = useNavigate();
  
  const [userId, setUserId] = useState<number | null>(null);
  const [company, setCompany] = useState<string>('');
  useEffect(() => {
    const fetchTokenData = async () => {
          let token = getTokenFromStorage();
          let decodedToken: TokenPayload | undefined;
    
          if (token) {
            try {
              decodedToken = jwtDecode<TokenPayload>(token);
              if (decodedToken.company) {
                setCompany(decodedToken.company);
              }
            } catch (error) {
              console.error('Erro ao decodificar token:', error);
            }
          }
    
          if (!decodedToken) {
            setTimeout(() => {
              token = getTokenFromStorage();
              if (token) {
                try {
              decodedToken = jwtDecode<TokenPayload>(token);
              if (decodedToken.company) {
                setCompany(decodedToken.company);
              }
            } catch (error) {
              console.error('Erro ao decodificar token:', error);
            }
              }
            }, 3000);
          }
        };
        fetchTokenData()
  }, []);

  const logoutFunction = () => {
    signOut(auth)
      .then(() => {
        alert('Usuário deslogado');
        navigate('/signin', { replace: true });
      })
      .catch((error) => {
        alert(`Erro ao deslogar: ${error.message}`);
      });
  };

  return (
    <div className="bg-white h-[100px] px-2 py-4 w-full sm:px-6 lg:px-8 flex justify-between items-center fixed z-[50]">
      {/* Logo */}
      <div className="flex items-end gap-8 px-2">
        <div>
          <span className="text-xs text-slate-500 font-bold py-2">Empresa</span>
          <h1 className="text-lg font-bold text-slate-900">{company || 'Carregando...'}</h1>
        </div>
        <div>
          <MenuTabs />
        </div>
      </div>
      <Popover>
        <PopoverTrigger asChild>
          <Avatar>
            <AvatarImage src={photoURL} alt="Avatar" />
            <AvatarFallback>CN</AvatarFallback>
          </Avatar>
        </PopoverTrigger>
        <PopoverContent align="end">
          <div className="py-2">
            <h4 className="text-sm font-bold text-slate-900">{auth.currentUser?.displayName || 'Usuário'}</h4>
            <h6 className="text-sm text-slate-900">{auth.currentUser?.email}</h6>
          </div>
          <Separator />
          <div className="py-2">
            <Button
              onClick={() => navigate('/profile-screen')}
              className="flex justify-between w-full bg-transparent text-slate-900 font-medium hover:bg-slate-100"
            >
              Perfil
              <User2 className="w-4 h-4" />
            </Button>
          </div>
          <Separator />
          <div className="py-2">
            <Button
              onClick={logoutFunction}
              className="flex justify-between w-full bg-transparent text-slate-900 font-medium hover:bg-slate-100"
            >
              Sair
              <LogOutIcon className="w-4 h-4" />
            </Button>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default NavBar;
